export default __webpack_public_path__ + "static/media/ChristjinJason.7782cd55.jpg";